import React, { useState } from 'react';
import { Box, Button, IconButton, TextField, Typography, Grid, FormControlLabel, Switch } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import useApi from '../../../Utilities/useAPI';
import { useCardDetailContext } from '../../../CardDetailContext';
import { useUserDetailContext } from '../../../UserDetailContext';

const Configuration = ({handleSuccess, handleFailure}) => {
  const { callApiFunction, loading, error } = useApi();
  const objectId = localStorage.getItem("objectId");

  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessage, seterrorMessage] = useState('');
  const { cardDetails } = useCardDetailContext();
  const { userDetails } = useUserDetailContext();

  const handleDeleteCard = async () => {
    try {
      const loginResponse = await callApiFunction('checkPassword', {
        email: userDetails.email,
        password,
        loginMethod: "username_password",
        loginType: "web"
      });

      console.log("Response of the login is", loginResponse, "and status code is", loginResponse.statusCode);

      if (loginResponse.statusCode === "1000") {
        console.log("Password verified successfully");

        try {
          const response = await callApiFunction('deleteTheCard', { User_ID: objectId, CardType: cardDetails.CardType, CardName: cardDetails.CardName });
          console.log("response", response);

          if (response.status === "success") {
            console.log('Card details deleted successfully');
            setdeleteConfirm(false);
            window.location.href = "/cards";
          } else {
            console.log('Failed to delete card details');
            seterrorMessage('Failed to delete the card.');
          }
        } catch (error) {
          console.error('Error deleting card details:', error);
          seterrorMessage('Failed to delete the card.');
        }

      } else {
        seterrorMessage('Incorrect password. Please try again.');
      }
    } catch (error) {
      console.error('Error logging in:', error);
      seterrorMessage('Entered Password is Wrong or Might be Server Problem');
    }
  };

  return (
    <div>
      <div className="container" style={{ paddingRight: "24px", paddingLeft: "24px" }}>
        <div className="card-edit-info-heading">
          <h5 className='fw-normal'>Configuration</h5>
          <span>Set-up business card</span>
        </div>

        <div className="mt-3">
          <h6 className='mb-2' style={{ color: "#000" }}>Advance Settings</h6>
          <div className="row mb-4">
            <p className="settings-title">Auto download contact</p>
            <p className="settings-description">Automatically download contacts to phone on view</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className="row mb-4">
            <p className="settings-title">Two-way contact sharing</p>
            <p className="settings-description">Collect contacts using their cards</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className="row mb-4">
            <p className="settings-title">GPS location</p>
            <p className="settings-description">Track locations of people viewing cards</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className="row mb-4">
            <p className="settings-title">Track IP location</p>
            <p className="settings-description">Analyze scan locations using the device's IP address</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className="row mb-4">
            <p className="settings-title">Primary Card</p>
            <p className="settings-description">Your go-to card for effortless connections and quick access</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className="row mb-4">
            <p className="settings-title">Pause Card</p>
            <p className="settings-description">Temporarily suspend your card to prevent interactions and updates</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className="row mb-4">
            <p className="settings-title">Block Card</p>
            <p className="settings-description">Disable your card to prevent any further transactions or access</p>
            <FormControlLabel
              control={<Switch />}
              label="Enable"
            />
          </div>

          <div className='mb-3'>
            <Button onClick={() => { setdeleteConfirm(true) }} className="delete-button_configuration">DELETE</Button>
          </div>
        </div>
      </div>
      {deleteConfirm &&
        <div className="lightbox-overlay">
          <div className="lightbox-content p-4">
            <div className='d-flex align-items-center justify-content-between'>
              <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>
                Are you sure you want to delete your card?
              </h6>
              <IconButton onClick={() => setdeleteConfirm(false)}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
            <Typography variant="body2" className="text-muted">This action cannot be undone. All information associated with this will be lost.</Typography>

            <div className='mt-3'>
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    label="Type Password" type='password'
                    fullWidth
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }} />
                </Grid>
              </Grid>
            </div>

            {errorMessage && <Typography variant="body2" color="error">{errorMessage}</Typography>}

            <div className='d-flex justify-content-end'>
              <Button onClick={() => setdeleteConfirm(false)} className="mx-2 mt-2">
                CANCEL
              </Button>
              <Button onClick={handleDeleteCard} className="delete-button_configuration mt-2">
                DELETE
              </Button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Configuration;
